import { createSelector } from 'reselect'
import { find, get } from 'lodash'
import { getThe, select } from 'src/store/selectors/utils'
import { selectCurrentHomeUser } from './index'
import { selectUnverifiedCELs } from './loans'

const getHomeData = state => state.home.data

const getHomeownerData = state => state.homeowner
const selectFromHomeownerData = select(getHomeownerData)

export const selectLoanFocus = selectFromHomeownerData(getThe('loanFocus'))
export const selectDisableAnimateLoanFocus = selectFromHomeownerData(
  getThe('disableAnimateLoanFocus')
)

export const selectStreamToken = createSelector(
  getHomeData,
  selectCurrentHomeUser,
  (home, user) => {
    const { id: homeRef } = home || {}
    const { notificationTokens: tokens } = user || {}

    return find(tokens, { homeRef }) || get(tokens, '[0]')
  }
)

const getHasCheckedLoanNumbers = state => state.homeowner.hasCheckedLoanNumbers

export const selectShouldCheckLoanNumbers = createSelector(
  selectUnverifiedCELs,
  getHasCheckedLoanNumbers,
  (unvLoans = [], hasChecked) => Boolean(unvLoans.length && !hasChecked)
)

export const selectIsDashFocused = createSelector(
  selectLoanFocus,
  focus => !focus
)
